import {ISearchAutocompleteItem} from 'types';

/**
 * Generate Suggestions autocomplete
 */
export const preparedSearchSuggestions = (
  searchValue: string,
  searchValueSuggestion: ISearchAutocompleteItem,
  autocompleteData: ISearchAutocompleteItem[] | undefined,
) => {
  const lowerCasedTrimmedSearchValue = searchValue.toLowerCase().trim();

  const tempArr = [];
  if (searchValue) tempArr.push(searchValueSuggestion);
  const finalArr = tempArr.concat(filterAutocomplete(autocompleteData, lowerCasedTrimmedSearchValue));
  return finalArr;
};

const filterAutocomplete = (
  autocompleteData: ISearchAutocompleteItem[] | undefined,
  lowerCasedTrimmedSearchValue: string,
) => {
  const tempArr: ISearchAutocompleteItem[] = [];
  if (!autocompleteData) return tempArr;
  for (let index = 0; index < autocompleteData.length; index++) {
    const element = autocompleteData[index];
    if (element.name.toLowerCase().includes(lowerCasedTrimmedSearchValue)) {
      tempArr.push(element);
    }
  }
  return tempArr;
};
